@if (hasText()) {
  <p
    #textElement
    class="text"
    [id]="textId"
    [class.clamped]="!expanded()"
  >
    {{ text() }}
  </p>

  @if (overflowing()) {
    <button
      class="toggle"
      type="button"
      [attr.aria-expanded]="expanded()"
      [attr.aria-controls]="textId"
      (click)="toggle()"
    >
      {{ toggleLabel() }}
    </button>
  }
}
